import { render, staticRenderFns } from "./notification-log.vue?vue&type=template&id=17b4d128&"
import script from "./notification-log.vue?vue&type=script&lang=js&"
export * from "./notification-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports